// HOOK OF INPUT 
import {useEffect, useState} from 'react'

const Dimention = () => {
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight
  }),
  setDimension = () => {
      getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
      })
  }

  useEffect(() => {
      window.addEventListener('resize', setDimension);
      
      return(() => {
          window.removeEventListener('resize', setDimension);
      })
  }, [screenSize])

  return {get: screenSize}
  
}

export default Dimention
